export default __webpack_public_path__ + "static/media/login-cover-mobile.8b1dae5a.png";